import { FormatDateOptions } from 'react-intl';

export enum ViewportBreakpoint {
  Desktop = 1280,
  Tablet = 1024,
  Mobile = 768,
}

export enum LocalStorageKey {
  SubmissionCreationMode = 'submission-creation-mode',
  EligibilityCheck = 'eligibility-check',
  ZipCode = 'zip-code',
}

export enum SessionStorageKey {
  Email = 'email',
}

export enum Currency {
  Euro = 'EUR',
}

export const DATE_WITH_TIME_OPTIONS: FormatDateOptions = {
  year: 'numeric',
  month: 'numeric',
  day: 'numeric',
  hour: 'numeric',
  minute: 'numeric',
};

export const DATE_OPTIONS: FormatDateOptions = {
  year: 'numeric',
  month: 'numeric',
  day: 'numeric',
};

export const ZIP_CODE_REGEX = /^(?!01000|99999)(0[1-9]\d{3}|[1-9]\d{4})$/;

// EU IBAN: one of 27 EU country codes + 2 check digits + 12–27 alphanumeric BBAN (ISO 13616)
// Spaces are allowed anywhere and ignored for length validation
// eslint-disable-next-line max-len
export const IBAN_REGEX_EU = /^(AT|BE|BG|HR|CY|CZ|DK|EE|FI|FR|DE|GR|HU|IE|IT|LV|LT|LU|MT|NL|PL|PT|RO|SK|SI|ES|SE)\s*\d\s*\d\s*([A-Z0-9]\s*){12,27}$/;
export const IBAN_MIN_LENGTH = 16;
export const IBAN_MAX_LENGTH = 31;
